import React from "react";
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer
} from "recharts";

/** Grouped Vertical bar chart information */
export default function RenderGroupedVerticalBarChart({
	data,
	config,
	GetSummary,
	filterData
}) {
	return (
		<div id={"vertical-bar-chart"} className={"hsc-margin"}>
			<ResponsiveContainer width={"100%"} height={450}>
				<BarChart
					data={data}
					width={"90%"}
					height={430}
					margin={{ top: 5, right: 30, left: 0, bottom: 5 }}
				>
					<Legend
						layout={"horizontal"}
						verticalAlign={"bottom"}
						align={"center"}
						height={40}
					/>
					<CartesianGrid strokeDasharray={""} vertical={false} />
					<XAxis
						dataKey={config.trend.key}
						angle={-50}
						minTickGap={-1000}
						tickMargin={50}
						tickLine={false}
						allowDataOverflow 
						height={160}
						stroke={"#FFFFFF"}
						type={"category"}
					/>
					<YAxis stroke={"#FFFFFF"} axisLine={false} type={"number"} />

					<Tooltip
						cursor={{ fill: "transparent" }}
						wrapperStyle={{ color: "#003865", outline: "none" }}
						labelStyle={{ color: "#003865" }}
					/>
					{config.columns.map((con, index) => {
						return (
							<Bar
								key={con.value + index}
								dataKey={con.value}
								fill={con.color}
								style={{ cursor: "pointer" }}
								onClick={data => { // this will needed for next release
									GetSummary(con, data, filterData);
								}}
								barSize={25}
								barCategoryGap={16}
								tick={{ wordWrap: "break-word" }}
							/>
						);
					})}
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
}
